import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { Nav4RoadmapsLegacy } from './index.legacy.tsx';
import { Nav4RoadmapsNext } from './index.next.tsx';

export const Nav4Roadmaps = componentWithFG(
	'jpd-sidebar-v4-for-roadmaps',
	Nav4RoadmapsNext,
	Nav4RoadmapsLegacy,
);
